import { TPlatform } from '../../types/platform';
import { TApplicationState } from '../../types/redux';

export const selectPlatform = (state: TApplicationState): TPlatform => state.platform;
